function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.704 5.84h14.592c1.003 0 1.824.79 1.824 1.754v10.523c0 .964-.82 1.754-1.824 1.754H4.704c-1.003 0-1.824-.79-1.824-1.754V7.594c0-.965.82-1.754 1.824-1.754zm8.263 7.313l5.964-3.586a.744.744 0 0 0 .365-.631c0-.588-.666-.939-1.186-.632L12 11.98 5.89 8.303c-.52-.307-1.186.044-1.186.632 0 .254.137.49.365.63l5.964 3.587c.593.36 1.34.36 1.934 0z",
  fill: "currentColor"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/mail.919085e8.svg";
export { SvgComponent as ReactComponent };